import request from '@/utils/request'
import SERVICE from './enums'

// getList
export function queryPage(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsVirtualTable/page`,
    method: 'post',
    data
  })
}

// export function update(data) {
//   return request({
//     url: `${SERVICE.API_MEDIA}/dsVirtualTable/update`,
//     method: 'post',
//     data
//   })
// }

export function add(data) {
  return request({
    url: `${SERVICE.API_MEDIA}/dsVirtualTable`,
    method: 'post',
    data
  })
}